module.exports = __webpack_public_path__ + "img/certificate-icon.34ef79cc.svg";